<div class="spinner-center" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>
<div class="loans-div" *ngIf="!loading">
    <form [formGroup]="group" class="w100" *ngIf="formArray.controls.length > 0">
        <div [formArrayName]="controlName">
            <mat-accordion>
                <div class="accordion-div" *ngFor="let control of formArray.controls; let i = index"
                    [formGroupName]="i">
                    <mat-expansion-panel #panel class="expansion-panel"
                        [expanded]="i === formArray.controls.length-1 && formArray.controls.length === 1">
                        <mat-expansion-panel-header *ngIf="control.get('status').value as status"
                            [ngClass]="status.key === UDEU_LOAN_BORROWED_STATUS ? 'loan-borrowed' : 'loan-inProgress'">
                            <mat-panel-title>
                                <span>{{control.get('name').value}} - {{status.value}}</span>
                                &nbsp;
                                <span *ngIf="control.get('startDate').value as startDate">({{startDate | date :
                                    'dd/MM/yyyy'}}<ng-container
                                        *ngIf="control.get('endDate').value as endDate">{{endDate ? '-' +
                                        (endDate | date : 'dd/MM/yyyy') : ''}}</ng-container>)</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <mat-icon>folder_shared</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="div-wrap">
                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.NAME' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="applicantName"></textarea>
                            </mat-form-field>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.EMAIL' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="email"></textarea>
                            </mat-form-field>

                            <div class="w45">
                                <smt-date-input [group]="formArrayGroup(i)" [controlName]="'requestDate'"
                                    [label]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.CREATED'"></smt-date-input>
                            </div>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.REASON' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="reason"></textarea>
                            </mat-form-field>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.LAST_YEAR_ENROLLMENT' |
                                    translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="lastYearEnrollment"></textarea>
                            </mat-form-field>

                            <mat-form-field class="w45">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.STUDENT' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="student"></textarea>
                            </mat-form-field>

                            <mat-form-field class="w100">
                                <mat-label>
                                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.FIELDS.MAIN_DATA.DESCRIPTION' | translate
                                    }}</mat-label>
                                <textarea matInput cdkTextareaAutosize formControlName="description"></textarea>
                            </mat-form-field>
                        </div>

                        <div class="action-buttons" *ngIf="isManager">
                            <button *ngIf="control.get('status').value.key !== UDEU_LOAN_IN_PROGRESS_STATUS" mat-raised-button color="primary" (click)="printReceipt(control.get('id').value, control.get('name').value)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.PRINT_RECEIPT_EXT' | translate">
                                <mat-icon>picture_as_pdf</mat-icon> {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.LOANS.STEPS.REGISTERS.PRINT_RECEIPT' | translate }}
                            </button>
                            <button mat-raised-button color="primary"
                                (click)="viewLoan(control.get('id').value)"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.VIEW_ITEM' | translate">
                                <mat-icon>visibility</mat-icon> {{ 'APP.ACTIONS.VIEW' | translate }}
                            </button>
                            <button mat-raised-button color="warn" (click)="revokeLoanRecord(control, i)"
                                *ngIf="!disabled && control.get('status').value.key !== UDEU_LOAN_BORROWED_STATUS"
                                [matTooltip]="'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.DELETE_ITEM_EXT' | translate">
                                <mat-icon>delete</mat-icon> {{
                                'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.DELETE_ITEM' | translate }}
                            </button>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </form>

    <mat-card *ngIf="formArray.controls.length == 0" class="center">
        <mat-card-content>
            {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.LOANS.EMPTY_ITEM' | translate }}
        </mat-card-content>
    </mat-card>
</div>